export function RouteLoading({ label }: { label: string }) {
  return (
    <main className="route-loading" aria-live="polite">
      <span className="loading-orbit" aria-hidden="true" />
      <span>{label}</span>
    </main>
  );
}
